import { Stamp, StampType } from "./Stamp";

export function StampCollection (props: {stamps : StampType[]})
{
    return <div className="stamp-collection">
        { props.stamps.map((s, i) => <Stamp key={i.toString()} type={s} />) }
    </div>
}